export enum StatusAutovistoria {
  "Aguardando coleta de evidência",
  "Aguardando análise do engenheiro",
  "Deferido",
  "Indeferido",
  'Aguardando análise do operador',
  'Em análise pelo operador',
  'Em análise pelo engenheiro'
}
